module.exports = ".navbar {\r\n  background: #eee;\r\n  padding-top: 15px;\r\n  padding-bottom: 8px;\r\n}\r\n"